import React, { useState } from 'react';
import { Search, MapPin, Briefcase, Clock, DollarSign, Filter } from 'lucide-react';
import { vacantes } from '../mock';

const BolsaTrabajo = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [ubicacion, setUbicacion] = useState('');

  const filteredVacantes = vacantes.filter(vacante => {
    const matchSearch = vacante.puesto.toLowerCase().includes(searchTerm.toLowerCase()) ||
                       vacante.empresa.toLowerCase().includes(searchTerm.toLowerCase());
    const matchUbicacion = ubicacion === '' || vacante.ubicacion.toLowerCase().includes(ubicacion.toLowerCase());
    return matchSearch && matchUbicacion;
  });

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      {/* Hero Section */}
      <div className="relative overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=1920&q=80" 
            alt="Bolsa de Trabajo"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/70" />
        </div>
        <div className="relative max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <h1 className="text-5xl font-bold text-white mb-4">Bolsa de Trabajo</h1>
          <p className="text-xl text-white/90 max-w-3xl">
            Encuentra oportunidades laborales en Yucatán. Conectamos empresas con talento calificado para impulsar el desarrollo económico del estado.
          </p>
        </div>
      </div>

      {/* Search Section */}
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="md:col-span-1">
              <label className="block text-sm font-medium text-gray-700 mb-2">Buscar puesto o empresa</label>
              <div className="relative">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" />
                <input
                  type="text"
                  placeholder="Ej: Ingeniero, Contador..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gray-400 focus:border-transparent transition-all"
                />
              </div>
            </div>
            
            <div className="md:col-span-1">
              <label className="block text-sm font-medium text-gray-700 mb-2">Ubicación</label>
              <div className="relative">
                <MapPin className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" />
                <input
                  type="text"
                  placeholder="Ej: Mérida, Valladolid..."
                  value={ubicacion}
                  onChange={(e) => setUbicacion(e.target.value)}
                  className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gray-400 focus:border-transparent transition-all"
                />
              </div>
            </div>

            <div className="md:col-span-1 flex items-end">
              <button className="w-full px-6 py-2 bg-[#8B1538] text-white rounded-lg hover:bg-[#6B0F2A] transition-colors font-medium flex items-center justify-center gap-2">
                <Filter className="h-5 w-5" />
                Filtrar
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Results Section */}
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="mb-6">
          <h2 className="text-2xl font-bold text-gray-900">
            {filteredVacantes.length} Vacantes Disponibles
          </h2>
        </div>

        <div className="space-y-4">
          {filteredVacantes.map((vacante) => (
            <div
              key={vacante.id}
              className="bg-white rounded-xl p-6 border border-gray-200 hover:shadow-lg hover:border-gray-300 transition-all duration-300"
            >
              <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
                <div className="flex-grow">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    {vacante.puesto}
                  </h3>
                  
                  <div className="flex flex-wrap gap-4 text-sm text-gray-600 mb-3">
                    <div className="flex items-center gap-1">
                      <Briefcase className="h-4 w-4" />
                      <span>{vacante.empresa}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <MapPin className="h-4 w-4" />
                      <span>{vacante.ubicacion}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <DollarSign className="h-4 w-4" />
                      <span>{vacante.salario}</span>
                    </div>
                  </div>

                  <div className="flex items-center gap-2">
                    <span className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-xs font-medium">
                      {vacante.tipo}
                    </span>
                    <div className="flex items-center gap-1 text-xs text-gray-500">
                      <Clock className="h-3 w-3" />
                      <span>{vacante.fecha}</span>
                    </div>
                  </div>
                </div>

                <div className="lg:flex-shrink-0">
                  <button className="w-full lg:w-auto px-6 py-2 bg-[#8B1538] text-white rounded-lg hover:bg-[#6B0F2A] transition-colors font-medium">
                    Ver Detalles
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {filteredVacantes.length === 0 && (
          <div className="text-center py-12">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Search className="h-8 w-8 text-gray-400" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">No se encontraron vacantes</h3>
            <p className="text-gray-600">Intenta con otros términos de búsqueda</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default BolsaTrabajo;